<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
    </avue-crud>
  </basic-container>
</template>

<script>
import { add, getDetail, getList, remove, update } from '@/api/v4ward/pay/paytradeall';
import { mapGetters } from 'vuex';

export default {
  data() {
    const date = new Date();
    date.setTime(date.getTime() - 3600 * 1000 * 24);
    let yesterday = this.dayjs(date).format('YYYY-MM-DD');

    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        sarchShow: true,
        searchMenuSpan: 6,
        calcHeight: 'auto',
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',
        addBtn: false,
        viewBtn: true,
        selection: false,
        menu: false,
        column: [
          {
            label: '交易时间',
            prop: 'payOrRefundTime',
            width: 100,
            type: 'datetime',
            searchRange: true,
            startPlaceholder: yesterday + ' 00:00:00',
            endPlaceholder: yesterday + ' 23:59:59',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            search: true,
            searchLabelWidth: 100,
            searchSpan: 8,
            hide: true,
            rules: [
              {
                required: true,
                message: '请输入支付成功/退款成功时间',
                trigger: 'change',
              },
            ],
          },
          {
            label: '支付渠道',
            prop: 'payPlatform',
            search: true,
            searchSpan: 4,
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=payChannel',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            rules: [
              {
                required: true,
                message: '请输入支付渠道',
                trigger: 'change',
              },
            ],
          },
          {
            label: '交易笔数',
            prop: 'tradeCount',
            rules: [
              {
                required: true,
                message: '请输入交易笔数',
                trigger: 'change',
              },
            ],
          },
          {
            label: '支付场景',
            prop: 'payScene',
            hide: true,
            search: true,
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=payScene',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            rules: [
              {
                required: false,
                message: '请输入支付场景',
                trigger: 'change',
              },
            ],
          },
          {
            label: '收入(元)',
            prop: 'settlementTotalFeeSum',
            rules: [
              {
                required: true,
                message: '请输入应结订单金额(元)',
                trigger: 'change',
              },
            ],
          },
          {
            label: '手续费(元)',
            prop: 'counterFeeSum',
            rules: [
              {
                required: true,
                message: '请输入手续费(元)',
                trigger: 'change',
              },
            ],
          },
          {
            label: '退款(元)',
            prop: 'settlementRefundFeeSum',
            rules: [
              {
                required: true,
                message: '请输入退款金额(元)',
                trigger: 'change',
              },
            ],
          },
          {
            label: '实际入账(元)',
            prop: 'enterFeeSum',
            rules: [
              {
                required: true,
                message: '请输入入账金额(元)',
                trigger: 'change',
              },
            ],
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.paytradeall_add, false),
        viewBtn: this.vaildData(this.permission.paytradeall_view, false),
        delBtn: this.vaildData(this.permission.paytradeall_delete, false),
        editBtn: this.vaildData(this.permission.paytradeall_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad(this.page);
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad(this.page);
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad(this.page);
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page);
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange() {
      this.onLoad(this.page, this.query);
    },
    onLoad(page) {
      page = page || this.page;

      const { payOrRefundTime } = this.query;
      let values = {
        ...this.query,
      };
      if (payOrRefundTime) {
        values = {
          ...this.query,
          startPayOrRefundTime: payOrRefundTime[0],
          endPayOrRefundTime: payOrRefundTime[1],
        };
        values.payOrRefundTime = null;
      }

      this.loading = true;
      if (!values.startPayOrRefundTime) {
        const date = new Date();
        date.setTime(date.getTime() - 3600 * 1000 * 24);
        let yesterday = this.dayjs(date).format('YYYY-MM-DD');
        values.startPayOrRefundTime = yesterday + ' 00:00:00';
        values.endPayOrRefundTime = yesterday + ' 23:59:59';
      }

      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, values)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style></style>
